module.exports = __webpack_public_path__ + "officialStatic/img/b1.e971663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/b1.png
// module id = iEqN
// module chunks = 0